import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AuthService } from '../user/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  public productListRef: firebase.firestore.CollectionReference;
  public productRef: firebase.firestore.DocumentReference;
  public userProfile: firebase.firestore.DocumentReference;

  constructor(
    private authService: AuthService,
    private firestore: AngularFirestore,
    ) {}

  //    productVendor: string,
  //    vendor: productVendor,
  async createProduct(
    campaignId: string,
    productName: string,
    productDescription: string,
    productPrice: number,
    productType: string,
    productPublic: boolean,
    productSalesTax: boolean,
    productAddress: boolean,
    productNotes: boolean
  ): Promise<firebase.firestore.DocumentReference> {
    const user: firebase.User = await this.authService.getUser();
    this.productListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/products`);
    this.userProfile = firebase.firestore().doc(`/userProfile/${user.uid}`);
    return this.productListRef.add({
      name: productName,
      description: productDescription,
      type: productType,
      price: productPrice,
      public: productPublic,
      salestax: productSalesTax,
      address: productAddress,
      notes: productNotes,
      createdate: Date()
    }).then((doc) => {
      console.log("Doc id " + doc.id);
      return doc;
    }).catch(error => {
      console.error(error);
      throw new Error(error);
    });
  }

  async getProductList(campaignId: string): Promise<firebase.firestore.QuerySnapshot> {
    this.productListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/products`);
    return this.productListRef.get();
  }

  async getFeaturedProducts(campaignId: string): Promise<firebase.firestore.QuerySnapshot> {
    this.productListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/products`);
    return this.productListRef.where("public", "==", true).orderBy('createdate').get();
  }

  getOrderedProducts(campaignId: string) {
    return this.firestore.collection(`campaigns/${campaignId}/products`, ref => ref.where('public', '==', true).orderBy('sequence')).valueChanges({idField: 'id'});
  }

  async getProductDetail(
    campaignId: string,
    productId: string
  ): Promise<firebase.firestore.DocumentSnapshot> {
    const user: firebase.User = await this.authService.getUser();
    this.productListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/products`);
    return this.productListRef.doc(productId).get();
  }

  async getProduct(
    campaignId: string,
    productId: string
  ): Promise<firebase.firestore.DocumentSnapshot> {
    console.log("Get Product");
    console.log(campaignId);
    console.log(productId);
    this.productListRef = firebase
      .firestore()
      .collection(`campaigns/${campaignId}/products`);
    return this.productListRef.doc(productId).get();
  }

  //    productVendor: string,
  //      vendor: productVendor,
  async updateProduct(
    campaignId: string,
    productId: string,
    productName: string,
    productDescription: string,
    productPrice: number,
    productType: string,
    productPublic: boolean,
    productSalesTax: boolean,
    productAddress: boolean,
    productNotes: boolean,
  ): Promise<any> {
    this.productRef = firebase
      .firestore()
      .doc(`campaigns/${campaignId}/products/${productId}`);
    return this.productRef.update({ 
      name: productName,
      description: productDescription,
      price: productPrice,
      type: productType,
      public: productPublic,
      salestax: productSalesTax,
      address: productAddress,
      notes: productNotes,
    });
  }

  async updateImage(
    campaignId: string,
    productId: string,
    productImage: any
  ): Promise<void> {
    this.productRef = firebase
      .firestore()
      .doc(`campaigns/${campaignId}/products/${productId}`);

    if (productImage != null) {
      const storageRef = firebase
        .storage()
        .ref(`/campaigns/${campaignId}/products/${productId}/productImage.png`);

      return storageRef
      //.putString(productImage, 'data_url', {
        .putString(productImage, 'base64', {
          contentType: 'image/png'
        })
        .then(() => {
          return storageRef.getDownloadURL().then(downloadURL => {
            return this.productRef
              .update({ image: downloadURL });
          });
        });   
    }
  }


}
